import { Button } from './app-ui/button';
import { Component, type ErrorInfo, type ReactNode } from 'react';
import Brand from './Brand';
import { useTranslation } from 'react-i18next';

interface Props { children: ReactNode }
interface State { error: Error | null }

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Tragenda render error', error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return <ErrorRecovery error={this.state.error} />;
  }
}

function ErrorRecovery({error}:{error:Error}) {
  const {t}=useTranslation();
  return <main className="error-page">
    <section className="error-recovery-card" role="alert">
      <Brand />
      <p className="eyebrow">{t('identity.recoveryEyebrow')}</p>
      <h1>{t('identity.recoveryTitle')}</h1>
      <p>{t('identity.recoveryBody')}</p>
      <Button variant="default" size="touch" className="button button-primary" onClick={() => window.location.reload()}>{t('identity.reload')}</Button>
      {import.meta.env.DEV && <pre>{error.message}</pre>}
    </section>
  </main>;
}
